import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './admin.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const AdminCafeVerde = () => {
  const [variedades, setVariedades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [stats, setStats] = useState({
    total_variedades: 0,
    stock_total: 0,
    certificaciones: 0,
    paises_importadores: 0
  });
  
  const [formData, setFormData] = useState({
    nombre: '',
    origen: '',
    altitud: '',
    perfil_taza: '',
    puntaje_sca: '',
    stock_kg: '',
    disponible: true,
    certificaciones: '',
    descripcion: ''
  });

  const certificacionesOptions = [
    'Orgánico',
    'Comercio Justo',
    'Rainforest Alliance',
    'UTZ Certified',
    'Bird Friendly',
    'Carbono Neutral'
  ];

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      // 🔥 CORREGIDO: Usar la tabla cafe_verde, no productos
      const response = await api.get('/cafe-verde');
      
      if (response.data) {
        setVariedades(response.data);
        
        // Calcular estadísticas
        const statsCalculadas = {
          total_variedades: response.data.length,
          stock_total: response.data.reduce((acc, item) => acc + (parseFloat(item.stock_kg) || 0), 0),
          certificaciones: new Set(response.data.flatMap(item => 
            item.certificaciones ? item.certificaciones.split(',').map(c => c.trim()) : []
          )).size,
          paises_importadores: 15
        };
        
        setStats(statsCalculadas);
      }
    } catch (error) {
      console.error('Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleCertificacionChange = (cert) => {
    const certificacionesActuales = formData.certificaciones ? formData.certificaciones.split(',').map(c => c.trim()) : [];
    let nuevasCertificaciones;

    if (certificacionesActuales.includes(cert)) {
      nuevasCertificaciones = certificacionesActuales.filter(c => c !== cert);
    } else {
      nuevasCertificaciones = [...certificacionesActuales, cert];
    }

    setFormData(prev => ({
      ...prev,
      certificaciones: nuevasCertificaciones.join(', ')
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 🔥 CORREGIDO: Enviar a la ruta de cafe-verde
      const cafeVerdeData = {
        nombre: formData.nombre,
        origen: formData.origen,
        altitud: formData.altitud,
        perfil_taza: formData.perfil_taza,
        puntaje_sca: formData.puntaje_sca,
        stock_kg: parseFloat(formData.stock_kg) || 0,
        disponible: formData.disponible,
        certificaciones: formData.certificaciones,
        descripcion: formData.descripcion
      };

      if (editingId) {
        await api.put(`/cafe-verde/${editingId}`, cafeVerdeData);
        alert('Variedad actualizada correctamente');
      } else {
        await api.post('/cafe-verde', cafeVerdeData);
        alert('Variedad creada correctamente');
      }
      
      resetForm();
      cargarDatos();
    } catch (error) {
      console.error('Error guardando variedad:', error);
      alert('Error al guardar la variedad: ' + (error.response?.data?.error || error.message));
    }
  };

  const resetForm = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({
      nombre: '',
      origen: '',
      altitud: '',
      perfil_taza: '',
      puntaje_sca: '',
      stock_kg: '',
      disponible: true,
      certificaciones: '',
      descripcion: ''
    });
  };

  const handleEdit = (variedad) => {
    setEditingId(variedad.id);
    setFormData({
      nombre: variedad.nombre || '',
      origen: variedad.origen || '',
      altitud: variedad.altitud || '',
      perfil_taza: variedad.perfil_taza || '',
      puntaje_sca: variedad.puntaje_sca || '',
      stock_kg: variedad.stock_kg || '',
      disponible: variedad.disponible !== false,
      certificaciones: variedad.certificaciones || '',
      descripcion: variedad.descripcion || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta variedad?')) {
      try {
        await api.delete(`/cafe-verde/${id}`);
        alert('Variedad eliminada');
        cargarDatos();
      } catch (error) {
        console.error('Error eliminando variedad:', error);
        alert('Error al eliminar la variedad');
      }
    }
  };

  const toggleDisponible = async (id, disponible) => {
    try {
      await api.patch(`/cafe-verde/${id}/toggle`, { disponible: !disponible });
      cargarDatos();
    } catch (error) {
      console.error('Error cambiando disponibilidad:', error);
      alert('Error al cambiar disponibilidad');
    }
  };

  const certificacionesArray = (certificaciones) => {
    return certificaciones ? certificaciones.split(',').map(c => c.trim()) : [];
  };

  if (loading) return <div className="loading">Cargando café verde...</div>;

  return (
    <div className="admin-cafe-verde">
      <div className="page-header">
        <div>
          <h1>🌱 Café Verde - Gestión de Variedades</h1>
          <p>Administra las variedades de café verde para venta por tonelada</p>
        </div>
        <button onClick={() => setShowForm(!showForm)} className="btn-primary">
          {showForm ? 'Cancelar' : '+ Nueva Variedad'}
        </button>
      </div>

      {/* Estadísticas */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">🌱</div>
          <div className="stat-info">
            <span className="stat-label">Variedades</span>
            <span className="stat-number">{stats.total_variedades || 0}</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📦</div>
          <div className="stat-info">
            <span className="stat-label">Stock Total</span>
            <span className="stat-number">{stats.stock_total?.toLocaleString() || 0} kg</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🏆</div>
          <div className="stat-info">
            <span className="stat-label">Certificaciones</span>
            <span className="stat-number">{stats.certificaciones || 0}</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🌍</div>
          <div className="stat-info">
            <span className="stat-label">Países Importadores</span>
            <span className="stat-number">{stats.paises_importadores || 15}+</span>
          </div>
        </div>
      </div>

      {/* Formulario */}
      {showForm && (
        <div className="form-section">
          <h2>{editingId ? 'Editar Variedad' : 'Nueva Variedad de Café Verde'}</h2>
          <form onSubmit={handleSubmit} className="cafe-verde-form">
            <div className="form-grid">
              <div className="form-group">
                <label>Nombre de la variedad *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  placeholder="Ej: Oro Natural Superior"
                  required
                />
              </div>

              <div className="form-group">
                <label>Origen *</label>
                <input
                  type="text"
                  name="origen"
                  value={formData.origen}
                  onChange={handleInputChange}
                  placeholder="Ej: Veracruz, México"
                  required
                />
              </div>

              <div className="form-group">
                <label>Altitud</label>
                <input
                  type="text"
                  name="altitud"
                  value={formData.altitud}
                  onChange={handleInputChange}
                  placeholder="Ej: 1,400 - 1,600 msnm"
                />
              </div>

              <div className="form-group">
                <label>Perfil de taza</label>
                <input
                  type="text"
                  name="perfil_taza"
                  value={formData.perfil_taza}
                  onChange={handleInputChange}
                  placeholder="Ej: Chocolate, nuez, caramelo"
                />
              </div>

              <div className="form-group">
                <label>Puntaje SCA</label>
                <input
                  type="text"
                  name="puntaje_sca"
                  value={formData.puntaje_sca}
                  onChange={handleInputChange}
                  placeholder="Ej: 85+"
                />
              </div>

              <div className="form-group">
                <label>Stock disponible (kg) *</label>
                <input
                  type="number"
                  name="stock_kg"
                  value={formData.stock_kg}
                  onChange={handleInputChange}
                  placeholder="0"
                  min="0"
                  step="0.01"
                  required
                />
              </div>

              <div className="form-group full-width">
                <label>Descripción</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder="Descripción detallada de la variedad"
                />
              </div>

              <div className="form-group full-width">
                <label>Certificaciones</label>
                <div className="certificaciones-grid">
                  {certificacionesOptions.map(cert => {
                    const certificacionesActuales = formData.certificaciones ? formData.certificaciones.split(',').map(c => c.trim()) : [];
                    return (
                      <label key={cert} className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={certificacionesActuales.includes(cert)}
                          onChange={() => handleCertificacionChange(cert)}
                        />
                        {cert}
                      </label>
                    );
                  })}
                </div>
              </div>

              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="disponible"
                    checked={formData.disponible}
                    onChange={handleInputChange}
                  />
                  Variedad disponible para venta
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary btn-large">
                {editingId ? 'Actualizar Variedad' : 'Guardar Variedad'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Grid de variedades */}
      {variedades.length === 0 ? (
        <div className="no-data">
          <p>No hay variedades de café verde registradas.</p>
          <button onClick={() => setShowForm(true)} className="btn-primary">
            + Crear primera variedad
          </button>
        </div>
      ) : (
        <div className="variedades-grid">
          {variedades.map(item => (
            <div key={item.id} className="variedad-card">
              <div className="variedad-header">
                <h3>{item.nombre}</h3>
                <span className={`variedad-status ${item.disponible ? 'disponible' : 'no-disponible'}`}>
                  {item.disponible ? 'Disponible' : 'Agotado'}
                </span>
              </div>

              <div className="variedad-details">
                <div className="detail-item">
                  <span className="detail-label">📍 Origen</span>
                  <span className="detail-value">{item.origen}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">⛰️ Altitud</span>
                  <span className="detail-value">{item.altitud}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">👃 Perfil</span>
                  <span className="detail-value">{item.perfil_taza}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">🏆 Puntaje</span>
                  <span className="detail-value">{item.puntaje_sca}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">📦 Stock</span>
                  <span className="detail-value">{parseFloat(item.stock_kg).toLocaleString()} kg</span>
                </div>
              </div>

              <div className="variedad-certificaciones">
                {certificacionesArray(item.certificaciones).map(cert => (
                  <span key={cert} className="cert-badge">{cert}</span>
                ))}
              </div>

              {item.descripcion && (
                <p className="variedad-descripcion">{item.descripcion}</p>
              )}

              <div className="variedad-acciones">
                <button 
                  onClick={() => handleEdit(item)}
                  className="btn-icon"
                  title="Editar"
                >
                  ✏️
                </button>
                <button 
                  onClick={() => toggleDisponible(item.id, item.disponible)}
                  className="btn-icon"
                  title={item.disponible ? 'Desactivar' : 'Activar'}
                >
                  {item.disponible ? '🔴' : '🟢'}
                </button>
                <button 
                  onClick={() => handleDelete(item.id)}
                  className="btn-icon"
                  title="Eliminar"
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminCafeVerde;